<template>
	<div class="base-centered-page bg-gray-900">
		<nav class="flex items-center justify-between pl-16 pr-16 overflow-hidden sm:pr-24">
			<slot name="nav-left">
				<BaseLogotype />
			</slot>
			<slot name="nav-right">
				<div
					v-if="!hideLogoutButton && $auth.isAuthenticated.value"
					class="flex items-center overflow-hidden gap-16 sm:gap-24"
				>
					<span class="flex-shrink text-gray-350 truncate"> Signed in as {{ $auth.user.value.email }} </span>
					<BaseButton class="text-gray-300 hover:text-gray-100 text-strong-base" @click="logout">
						Logout
					</BaseButton>
				</div>
			</slot>
		</nav>
		<section class="flex justify-center overflow-auto">
			<slot />
		</section>
		<ButtonHelp v-if="!hideHelpButton" />
	</div>
</template>

<script>
import analytics from 'shared/utils/analytics'
import ButtonHelp from 'shared/components/ButtonHelp.vue'

export default {
	name: 'BaseCenteredPage',
	components: {ButtonHelp},
	props: {
		hideHelpButton: Boolean,
		hideLogoutButton: Boolean,
	},
	methods: {
		logout() {
			analytics.track('Logout Button Clicked')
			this.$auth.logout({logoutOfAllTargets: true})
		},
	},
}
</script>

<style scoped>
.base-centered-page {
	width: 100vw;
	height: 100vh;
	overflow: hidden;
	display: grid;
	grid-template-columns: 1fr;
	grid-template-rows: 48px 1fr;
}
</style>
